import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export default function initColsParallax() {
  let mm = gsap.matchMedia();
  let breakPoint = 768;
  document.querySelectorAll('[data-cols-parallax-section]').forEach(section=> {
    // return;
    const colLeft = section.querySelector('[data-col-left]');
    const colRight = section.querySelector('[data-col-right]');
    
    const leftImageFlag = colLeft.querySelector('.img-holder')? true : false;
    const rightImageFlag = colRight.querySelector('.img-holder')? true : false;
    
    mm.add({
      isDesktop: `(min-width: ${breakPoint}px)`,
      isMobile: `(max-width: ${breakPoint - 1}px)`,
      reduceMotion: "(prefers-reduced-motion: reduce)",
    },
    (context) => {
      let { isDesktop } = context.conditions;
      const tl = gsap.timeline();

      const sceneLeft = gsap.fromTo(colLeft, {y: isDesktop ? (leftImageFlag? 70 : colLeft.clientHeight / 3) : 60 }, {y: isDesktop ? (leftImageFlag? -70 : colLeft.clientHeight / -3): -40, ease: 'none'});
      const sceneRight = gsap.fromTo(colRight, {y: isDesktop ? (rightImageFlag? 70 : colRight.clientHeight / 1.2) : 48}, {y: isDesktop ?  (rightImageFlag? -70 : colRight.clientHeight / -1.2): -20,  ease: 'none'});
      tl.add(sceneLeft, 0).add(sceneRight, 0);
      
      ScrollTrigger.create({
        trigger: section,
        start: 'top bottom',
        end: 'bottom top',
        // markers: true,
        scrub: 1,
        animation: tl
      })

      return () => {
        // optionally return a cleanup function that will be called when none of the conditions match anymore (after having matched)
        // it'll automatically call context.revert() - do NOT do that here . Only put custom cleanup code here.
      };
    }
  );

    
  });
}